import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';


const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const imagenes = [
  {
    label: 'Sin traslados',
    imgPath:
      'http://www.ospedyc.org/telemedicina/assets/images/telemedicina-1.png',
  },
  {
    label: 'Cuidando tu salud',
    imgPath:
      'http://www.ospedyc.org/telemedicina/assets/images/telemedicina-3.png',
  },
  {
    label: 'Desde donde estes',
    imgPath:
      'http://www.ospedyc.org/telemedicina/assets/images/telemedicina-2.png',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 900,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 700,
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    width: '100%',
  },
}));

export const CarouselImagen = () => {
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);

    const handleStepChange = (step) => {
      setActiveStep(step);
    };
  
    return (
      <div className={classes.root}>
        <AutoPlaySwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
            {imagenes.map((step, index) => (
        <div key={step.label}>
          {Math.abs(activeStep - index) <= 2 ? (
            <div style={{ position: 'relative' }}>
              <Typography align="center" variant="h3" color="primary" style={{ position: 'absolute', top: '80%', left: '50%', transform: 'translate(-50%, -50%)', fontWeight: 'bold' }}>{step.label}</Typography>
              <img className={classes.img} src={step.imgPath} alt={step.label} />
            </div>
          ) : null}
        </div>
      ))}
        </AutoPlaySwipeableViews>
        {/* <MobileStepper
          steps={maxSteps}
          position="static"
          variant="text"
          activeStep={activeStep}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              Back
            </Button>
          }
        /> */}
      </div>
    );
  }